import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';

@Component({
  selector: 'app-featured-case-studies',
  templateUrl: './featured-case-studies.component.html',
  styleUrls: ['./featured-case-studies.component.scss'],
  imports: [TranslatePipe, LangRouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturedCaseStudiesComponent {
  public readonly studies = [
    { key: 'yettel', logo: 'assets/img/CaseStudies/yettel.svg', color: '#00A651' },
    { key: 'flying_tiger', logo: 'assets/img/CaseStudies/flying-tiger.svg', color: '#E4002B' },
    { key: 'o2', logo: 'assets/img/CaseStudies/o2.svg', color: '#0050AA' },
  ];
}
